import React from "react";
import {TouchableOpacity, View, StyleSheet, Platform, Linking} from "react-native";
import {styleVars} from "../../app-style-vars";
import PtText from "../core/pt-text/pt-text";
import {getTranslation} from "../../helpers/getTranslation";
import getConfig from "../../environment";
import {getSubdomain} from "../../helpers/getSubdomain";

const hybrisBase = getConfig()?.hybrisBaseUrl.replace(/{subdomain}/g, getSubdomain());
const termsOfUseUrl = `${hybrisBase}/termsandconditions`;

export default function PtTermsOfUse(props) {
  const useInternalPage = props.useInternalLink || false;

  const openTermsOfUse = () => {
    if(useInternalPage) {
      props.navigation.navigate('TermsOfUse');
    } else {
      if(Platform.OS === 'web') {
        window.open(termsOfUseUrl)
      } else {
        Linking.openURL(termsOfUseUrl);
      }
    }
  };

  return (
    <View style={styles.footerLinkContainer}>
      <TouchableOpacity onPress={() => openTermsOfUse()}>
        <PtText style={styles.footerLinkText}>{getTranslation('footer.terms.of.use.link.text')}</PtText>
      </TouchableOpacity>
    </View>
  )
}

const styles = StyleSheet.create({
  footerLinkContainer: {
    paddingHorizontal: styleVars.rem(1),
    paddingVertical: styleVars.rem(.5),
    marginBottom: styleVars.rem(.5),
  },
  footerLinkText: {
    fontSize: styleVars.rem(.875),
    color: styleVars.boschDarkBlue,
  },
});
